import AttributeStore from './attributeStore';

class SaleGaragesAttributes extends AttributeStore {
  getAttributes () {
    return [
      {
        title: 'Характеристики ' + this.getCase(),
        items: [
          this.getSquareTotal(),
          this.getSizes(),
          this.getSecurityProtection(),
          this.getRepairPit(),
          this.getCellar(),
          this.getElectricity(),
          this.getHasHeating(),
          this.getWater(),
          this.getCanalization(),
          this.getReference()
        ].filter(Boolean)
      }
    ];
  }
}

export default SaleGaragesAttributes;



// WEBPACK FOOTER //
// ./src/classes/announcement/attributes/saleGaragesAttributes.js